export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_WITH_WEEKDAY_FORMAT = "YYYY-MM-DD (dddd)";
